import { UserPermission } from 'constants/userPermission';
import { ApprovalThreadType } from '../types';

export const getThreadShowPermissions = (
  thread: ApprovalThreadType,
): UserPermission[] => {
  return thread === 'internal'
    ? [UserPermission.POST_COMMUNICATION_INTERNAL_SHOW]
    : [UserPermission.POST_COMMUNICATION_CLIENT_SHOW];
};

export const getThreadApprovePermissions = (
  thread: ApprovalThreadType,
): UserPermission[] => {
  return thread === 'internal'
    ? [UserPermission.POST_INTERNAL_APPROVE]
    : [UserPermission.POST_CLIENT_APPROVE];
};
